<template>
	<div :class="{ 'list': true, 'list--loading': loading }">
		<!-- Hide table entirely if set to only "new" opportunities and no results -->
		<Vuetable
            ref="vuetable"
            api-url="opportunities"
            pagination-path="meta"
            :fields="fields"
            :css="css"
            :http-fetch="fetch"
            :load-on-start="loadOnStart"
            :append-params="filters"
            :row-class="onRowClass"
            :min-rows="loading ? 10 : null"
            :no-data-template="loaded && !newOnly ? 'No opportunities found' : ''"
            @vuetable:pagination-data="onPaginationData"
            @vuetable:loading="onLoading"
            @vuetable:loaded="onLoaded"
            @vuetable-load-error="onLoadError"
		/>

		<!-- Error while loading -->
		<div class="list__error" v-if="error">
			<span class="h2">Unable to load opportunities.</span>
			<button class="btn btn--link" @click.prevent="load">Retry</button>
		</div>

		<!-- Showing only "new" opportunities and no results -->
		<div class="list__empty" v-if="newOnly && empty">
			<span class="h2">You're all up to date!</span>
			<router-link to="/opportunities" class="btn btn--link">View all opportunities</router-link>
		</div>

		<Pagination ref="pagination" @vuetable-pagination:change-page="onChangePage"></Pagination>
	</div>
</template>

<script>
	import Vue from 'vue';
	import Vuetable from 'vuetable-2/src/components/Vuetable';
	import ColumnOpportunity from './ColumnOpportunity';
	import ColumnSector from './ColumnSector';
	import ColumnCreated from './ColumnCreated';
	import Pagination from './Pagination';
	import FilterableList from './FilterableList';
	import ColumnMandated from './ColumnMandated';

	Vue.component('column-opportunity', ColumnOpportunity);
	Vue.component('column-sectors', ColumnSector);
	Vue.component('column-mandated', ColumnMandated);
	Vue.component('column-created', ColumnCreated);

	export default {
		name: 'ListOpportunities',
		mixins: [ FilterableList ],
		components: {
			Pagination,
			Vuetable,
		},
        methods: {
            resetPagination() {
                this.$refs.vuetable.changePage(1)
            },
        },
		data() {
			return {
				fields: [
					{
						name: '__component:column-opportunity',
						sortField: 'project_name',
						title: 'Opportunity',
					},
					{
						name: '__component:column-mandated',
						sortField: 'mandated',
						title: 'Mandated',
						width: '100px',
						dataClass: 'data-label mandated'
					},
					{
						name: 'dealType',
						sortField: 'deal_type',
						title: 'Deal Type',
						width: '200px',
						dataClass: 'data-label deal-type'
					},
					{
						name: 'companyRevenue',
						sortField: 'company_revenue',
						title: 'Rev.',
						width: '80px',
						dataClass: 'data-label company-revenue'
					},
					{
						name: '__component:column-sectors',
						title: 'Main Sector',
						width: '180px',
						dataClass: 'data-sector'
					},
					{
						name: '__component:column-created',
						sortField: 'created_at',
						title: 'Created',
						titleClass: 'right',
						width: '100px',
						dataClass: 'data-label created-at'
					}
				],
			};
		},
	}
</script>
